import { getPreferredClient } from '@/lib/auth';

export const CHAT_ID = import.meta.env.VITE_FRONT_CHAT_ID as string | undefined;

export interface EmailHashResponse {
  code: string;
  message: string;
  success: boolean;
  userHash: string;
  email: string;
}

export const getFrontChatUserHash = async (): Promise<EmailHashResponse> => {
  const path = '/Auth/hash-email';
  const { data } = await getPreferredClient().post<EmailHashResponse>(path);
  return data;
};
